import React, { useEffect } from 'react';
import { RecoilState, useRecoilState, useRecoilValue } from 'recoil';
import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import { Slice } from 'features/morphing/state/parameterAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { SymmetryDisableState } from 'features/morphing/state/stageParameterAtoms';

interface Props {
  booleanState: RecoilState<boolean>;
  label: string;
  sliceState: RecoilState<Slice>;
  maxValue: number;
}

const checkboxSx = {
  color: '#e9e9e9',
  '&.Mui-checked': {
    color: '#1976d2',
  },
  transform: 'scale(.9)',
  padding: '4px',
};

export const SymmetryForm: React.FC<Props> = ({
  booleanState,
  label,
  sliceState,
  maxValue
}) => {
  const [checked, setChecked] = useRecoilState(booleanState);
  const [symmetryDisable, setSymmetryDisable] = useRecoilState(SymmetryDisableState);
  const slice = useRecoilValue(sliceState);

  useEffect(() => {
    if (slice.stop <= Math.floor(maxValue / 2) && maxValue > 0) {
      setSymmetryDisable(false);
    } else {
      setSymmetryDisable(true);
      setChecked(false);
    }
  }, [slice, maxValue, setSymmetryDisable, setChecked]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  return (
    <Box component="div" sx={{ paddingTop: 1 }}>
      <Grid container alignItems="center" spacing={0.5}>
        <Grid item xs={5}>
          <CustomTypography>
            {label}
          </CustomTypography>
        </Grid>
        <Grid item xs={7}>
          <FormControlLabel
            control={
              <Checkbox
                sx={checkboxSx}
                checked={checked}
                onChange={handleChange}
                disabled={symmetryDisable}
              />
            }
            label=''
          />
        </Grid>
      </Grid>
    </Box>
  );
};
